export default "__VITE_ASSET__D91vdoYx__"